
import market1        from '@/components/admin/ProductCombinationsToMarket.vue'
import market2        from '@/components/admin/MarketBasicCommission.vue'
import market3        from '@/components/admin/MarketProductPromo.vue'
import market4        from '@/components/admin/SendOrderToPrinter.vue'
import market5        from '@/components/frontOffice/ShootingCheckList.vue'
import market6        from '@/components/admin/MarketPushZone.vue'


//import market7        from '@/components/frontOffice/caposerio/GiftCardFormCreate.vue'
//import market8        from '@/components/frontOffice/caposerio/GiftCardFormValidate.vue'
//import market6        from '@/components/market/ShootingSlot.vue'

const flag = true

const menuId = 'mk1'
const routes = [  
    {
        path        : '/market1',
        name        : 'market1',
        component   : market1,
        meta        : { name : 'Associazione prodotti', visible : flag ,icon : 'fas fa-cog',menu:menuId,color:'red'},
        
    },
        
    {
        path        : '/market2',
        name        : 'market2',
        component   : market2,
        meta        : { name : 'Registrazione commissione base', visible : flag ,icon : 'fas fa-percentage',menu:menuId,color:'violet'},
        
    },
    {
        path        : '/market3',
        name        : 'market3',
        component   : market3,
        meta        : { name : 'Gestione promo', visible : flag ,icon : 'fas fa-pen-square',menu:menuId,color:'green'},
        
    },
        
    {
        path        : '/market4',
        name        : 'market4',
        component   : market4,
        meta        : { name : 'Invio ordine a stampante', visible : flag ,icon : 'fas fa-external-link-alt',menu:menuId,color:'green'},
        
    },
    {
        path        : '/market5', 
        name        : 'market5',
        component   : market5,
        meta        : { name : 'Shooting check List', visible : true ,icon : 'fas fa-camera-retro',menu:menuId,color:'#800000'},   
    },
    
    {
        path        : '/market6', 
        name        : 'market6',
        component   : market6,
        meta        : { name : 'PUSH ZONE', visible : true ,icon : 'fas fa-cloud-upload-alt',menu:menuId,color:'#800000'},   
    },
    
    /*
    {
        path        : '/market7', 
        name        : 'market7',
        component   : market7,
        meta        : { name : 'REGISTRAZIONE GIFT CARD', visible : true ,icon : 'fas fa-cloud-upload-alt',menu:menuId,color:'#800000'},   
    },
    {
        path        : '/market8', 
        name        : 'market8',
        component   : market8,
        meta        : { name : 'CONTROLLO GIFT CARD', visible : true ,icon : 'fas fa-cloud-upload-alt',menu:menuId,color:'#800000'},   
    },
    */
    
    


]
export default routes